import { LipaBidhaaPageHeader } from "../components/LipaBidhaa/shared/LipaBidhaaPageHeader";
import { PaymentFlowContainer } from "../components/LipaBidhaa/shared/PaymentFlowContainer";
import { PAYMENT_TYPES } from "../components/LipaBidhaa/config/lipaBidhaaConfig";

function Paybill() {
  return (
    <div className="p-6">
      <LipaBidhaaPageHeader />
      <PaymentFlowContainer paymentType={PAYMENT_TYPES.PAYBILL} />
    </div>
  );
}

export default Paybill;
